export default __webpack_public_path__ + "unmute.svg";